import { CallState, LoadingState } from '@lcs/shared/api';
import { createReducer, on } from '@ngrx/store';
import { onReset } from 'src/app/authentication/reset-reducer';
import { CallCostDetailView } from '../models/call-cost-detail-view.model';
import { GetProviderCallRateDetail_providerCallRate } from '../queries/generated/GetProviderCallRateDetail';
import * as CallCostDetailActions from './call-cost-detail.actions';

export const callCostDetailFeatureKey = 'callCostDetail';

export interface State {
   callCost: CallCostDetailView | null;
   callState: CallState;
   currentCallCostId: number | null;
}

export const initialState: State = {
   callState: LoadingState.Init,
   currentCallCostId: null,
   callCost: null,
};

export const reducer = createReducer(
   initialState,
   onReset(initialState),
   on(CallCostDetailActions.callCostDetailLoad, CallCostDetailActions.callCostDetailCancel, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
         callCost: null,
      };
   }),
   on(CallCostDetailActions.updateCallCostId, (state, { callCostId }) => {
      return {
         ...state,
         currentCallCostId: callCostId,
      };
   }),
   on(CallCostDetailActions.loadCallCostDetailSuccess, (state, action) => {
      const callCost: GetProviderCallRateDetail_providerCallRate = action.data;
      return {
         ...state,
         callState: LoadingState.Loaded,
         callCost: {
            ...callCost,
         },
      };
   }),
   on(CallCostDetailActions.loadPageNoCallCost, (state) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
      };
   }),
   on(CallCostDetailActions.loadCallCostDetailFailure, (state, action) => {
      return {
         ...state,
         callState: action,
      };
   }),
   on(CallCostDetailActions.saveCallCostDetail, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
      };
   }),
   on(CallCostDetailActions.saveCallCostDetailFailure, CallCostDetailActions.callCostDetailAccessDenied, (state) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
      };
   })
);
